<template>
    <defaultTemplate>
        <div class="card rounded">
        	<div class="card-content">
	            <div class="columns">
	                <div class="column is-9 border-right-solid">
	                	<h1 class="mg-b-2 has-text-weight-bold">Changelog</h1>
	                    <markdown-it-vue class="md-body" :content="fileContent" />
	                </div>
	                <div class="column is-3 th has-text-weight-normal">
	                    <div class="sticky">
	                       <ul>
	                            <li v-if="index < 18" v-for="(data,index) in toc.toc" :class="{isActive: data.href === activeBlock}">
	                                <a class="has-text-grey-dark has-text-weight-light" @click="scrollIntoView($event,data.href)" :href="data.href">
	                                    {{data.label}}
	                                    
	                                </a>
	                                <ul class="pd-l-3" v-if="data.href === activeBlock">
	                                    <li v-for="sub in data.subMenu" class="font-16">
	                                        <a  @click="scrollIntoView($event,sub.href)" :href="sub.href" class="has-text-grey-dark  has-text-weight-light">{{sub.label}}</a>
	                                    </li>
	                                </ul>
	                            </li>
	                            <li v-if="toc.toc.length > 18">
	                                <a href="#" class="c-text-gray  has-text-weight-light">
	                                   Older releases
	                                </a>
	                            </li>
	                        </ul> 
	                    </div>
	                    
	                </div>
	            </div>
	        </div>
        </div>
    </defaultTemplate>
</template>
<script>
import defaultTemplate from '@/template/DefaultTemplate'
import { offsetTop, scrollTo ,makeTOC } from '@/service/util'
import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'
import txt from '!!raw-loader!../../CHANGELOG.md';
export default {
    name: "changeLog",
     components: {
        MarkdownItVue,
        defaultTemplate
      },
    data() {
        return {
            toc:[],
            activeBlock:null,
            page:{window:0,top:0},
          fileContent: txt,
          textFor: txt,
          options: {
              markdownIt: {
                linkify: true
              },
              linkAttributes: {
                attrs: {
                  target: '_blank',
                  rel: 'noopener'
                }
              },icons: 'font-awesome',
              githubToc: {
                tocFirstLevel: 2,
                tocLastLevel: 3,
                tocClassName: 'toc',
                anchorLinkSymbol: '',
                anchorLinkSpace: false,
                anchorClassName: 'anchor',
                anchorLinkSymbolClassName: 'octicon octicon-link'
              }
            }
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.cutWord()
        this.$store.commit('setSpaPage',null)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods:{
        elementInViewport(el) {
          var top = el.offsetTop;
          var height = el.offsetHeight;

          while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
          }
           this.page.window = window.pageYOffset + window.innerHeight
           this.page.top = (top + height)
          return (
            top >= window.pageYOffset &&
            (top + height) <= (window.pageYOffset + window.innerHeight)
          );
        },
        handleScroll() {
          const elementsInViewArray = this.toc.toc.map(number => {
            const el = document.getElementById(number.href.replace('#',""));
            if(this.elementInViewport(el)) {
              return number.href;
            }
          });
          this.activeBlock = elementsInViewArray.find(number => number)
        },
        cutWord(){
            let txtLength = this.textFor.length 
            let txtData = this.textFor.toString()
            let subData = this.textFor.toString()
            let allData = []
            let allSub = []
            for (var i = 0; i < txtLength; i++) {
                let anchor = txtData.match(/[#]+[#] [[]+[\S]+/)
                if(anchor != null){
                    allData.push(anchor[0])
                    var res = txtData.replace(anchor[0],"");
                    txtData = res
                }  
            }
            for (var i = 0; i < txtLength; i++) {
                let anchorSub = subData.match(/[#]+[#]+[#]+[ \w.\d]+/)
                if(anchorSub != null){
                    allSub.push(anchorSub[0])
                    var res = subData.replace(anchorSub[0],"");
                    subData = res
                }
            }
            this.toc = makeTOC(allData,allSub)
        },
        scrollIntoView(evt, href) {
            evt.preventDefault()
            evt.stopPropagation()
            const id = (href || '').replace(/#/g, '')
            const $el = document.body.querySelector(`[id="${id}"]`)
            if ($el) {
                const scroller = document.scrollingElement || document.documentElement || document.body
                scrollTo(scroller, offsetTop($el) - 70, 100, () => {
                    $el.tabIndex = -1
                })
            }
        }
    }
}
</script>
<style scoped>
.sticky li.isActive > a,.sticky li > a:hover{
    color: #00a79d;
}
.log-lists li{
    list-style: disc
}
.mg-l-35{
    margin-left: 35px!important;
}
.sticky{
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    padding: 20px;
    font-size: 20px;
}
p{
    list-style-type: disc;
}
</style>
